import React from "react";
import { FaStar } from "react-icons/fa";
import Footer from "../components/Footer";
import Header from "../components/Header";
import boy from "../img/girl.png";
import both from "../img/both.png";
import main from "../img/main.png";
import Children2Img from "../img/2_children.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Review from "../components/Review";
import Package from "../components/Package";
import Protect from "../components/Protect";
import { Autoplay } from "swiper/modules";
import certificate1 from "../img/cert_external_threat.jpg";
import certificate2 from "../img/cert_internal_lockdown.jpg";
import certificate3 from "../img/cert_combative.png";
import certificate4 from "../img/cert_internal_threat.jpg";
import certificate6 from "../img/cert_shelter_place.jpg";
import certificate7 from "../img/cert_six_of_six.jpg";

const reviews = [
  {
    text: "After taking the AngelWatch course, I finally feel prepared for any emergency—and that peace of mind is truly priceless.",
    name: "Emily Harris",
    work: "Kindergarten Teacher",
  },
  {
    text: "This is the best training I’ve seen in 25+ years of education. My staff feels confident and prepared.",
    name: "Lauren Mitchell",
    work: "Daycare Director",
  },
  {
    text: "I no longer feel anxious about emergencies at my school. AngelWatch has given us a system that actually works.",
    name: "Karen Williams",
    work: "Assistant Principal",
  }
];

const certificates = [
  {
    certImg: certificate2,
    certTitle: "INTERNAL LOCKDOWN PROCEDURES"
  },
  {
    certImg: certificate4,
    certTitle: "ACTIVE SHOOTER / INTERNAL THREAT"
  },
  {
    certImg: certificate1,
    certTitle: "ACTIVE SHOOTER / EXTERNAL THREAT"
  },
  {
    certImg: certificate3,
    certTitle: "COMBATIVE INTERNAL THREAT / PARTNER"
  },
  {
    certImg: certificate6,
    certTitle: "SHELTER AND PLACE"
  },
  {
    certImg: certificate7,
    certTitle: "ACTIVE SHOOTER Six of Six trainings completed"
  }
]

export default function Include() {
  return (
    <>
      <Header />
      <div className="font-sans mb-40">
        <div className="relative text-white">
          {/* Hero Image */}
          <div className="lg:h-[354px] h-[150px] w-full overflow-hidden">
            <img
              src={main}
              alt="How it works"
              className="w-full h-full object-cover"
            />
          </div>
          {/* Content Overlay */}
          <div className="absolute inset-0 flex items-center justify-start">
            <div className="max-w-7xl w-full mx-auto px-4">
              <div className="flex flex-col">
                <h1
                  style={{ fontFamily: "Fredoka" }}
                  className="lg:text-[61px] text-[24px] font-bold mb-2 text-white"
                >
                  Included
                </h1>
                <div style={{ fontFamily: "Poppins" }} className="text-white">
                  Home &gt; <span className="text-white">Included</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="">
          <div className="">
            {/* Top Section */}
            <div className="px-6 py-10  mx-auto text-center">
              {/* Title */}
              <h1
                style={{ fontFamily: "Fredoka" }}
                className="lg:text-[34px] text-[20px] font-semibold mb-10"
              >
                Emergency Management System and Training for Schools and
                Daycares | <span className="text-black">AngelWatch</span>
              </h1>

              {/* Certificates Row */}
              <div className="container mx-auto">
                <Swiper
                  spaceBetween={20}
                  slidesPerView={1}
                  autoplay={{
                    delay: 2500, // 2.5 seconds
                    disableOnInteraction: false, // autoplay won't stop on user swipe
                  }}
                  modules={[Autoplay]}
                  breakpoints={{
                    640: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                  }}
                  className="mb-10"
                >
                  {certificates.map((e, idx) => (
                    <SwiperSlide key={idx}>
                      <div className="w-80 mx-auto text-center">
                        <img
                          src={e.certImg}
                          alt={e.certTitle}
                          className="w-full border border-gray-300 shadow"
                        />
                        <p
                          style={{ fontFamily: "Fredoka" }}
                          className="mt-2 lg:text-[24px] text-14 font-medium"
                        >
                          {e.certTitle}
                        </p>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
              {/* Description Text */}
              <div
                style={{
                  fontFamily: "poppins",
                  fontSize: "18px",
                  color: "black",
                }}
                className="text-left lg:px-10 px-5  mb-10 container mx-auto space-y-4 text-[18px] text-gray-700 leading-relaxed"
              >
                <p
                  className="lg:text-[18px] text-[14px]"
                  style={{ fontFamily: "Poppins" }}
                >
                  The AngelWatch Certification Program, part of the AngelWatch
                  National Accreditation Program under the AngelWatch
                  Foundation, is the only emergency management and certification
                  training program designed specifically for those responsible
                  for children in child-based environments: schools, daycares,
                  and child care facilities. This program goes far beyond active
                  shooter procedures—distinguishing between internal lockdowns,
                  evacuations, and shelter-in-place emergencies.
                </p>
                <p
                  className="lg:text-[18px] text-[14px]"
                  style={{
                    fontFamily: "poppins",

                    color: "black",
                  }}
                >
                  Today’s reality: emergencies now come in many forms—active
                  shooter scenarios, medical emergencies, fire drills,
                  environmental hazards, chemical spills, bomb threats,
                  kidnappings, and more. The question is, “Are you prepared?”
                  This course ensures that you are. The most critical
                  factor—staff awareness, training, and system response—can make
                  the difference between life and death.
                </p>
                <p
                  className="lg:text-[18px] text-[14px]"
                  style={{
                    fontFamily: "poppins",

                    color: "black",
                  }}
                >
                  Unlike generalized active shooter training courses, the
                  AngelWatch Certification system offers clear step-by-step
                  drills for every type of incident, customized to your specific
                  organization and location. You’ll be able to create a written
                  protocol manual for your school or center—one that’s
                  recognized and certified by emergency professionals.
                </p>
                <p
                  className="lg:text-[18px] text-[14px]"
                  style={{
                    fontFamily: "poppins",

                    color: "black",
                  }}
                >
                  While schools, daycares, and even hospitals follow protocols
                  set by the state or local authorities, the AngelWatch model
                  fills the gap—most certified workplaces never test their
                  systems, and few require real scenario drills. AngelWatch
                  drills help teams practice real-life emergencies and establish
                  muscle memory.
                </p>
                <p
                  className="lg:text-[18px] text-[14px]"
                  style={{
                    fontFamily: "poppins",

                    color: "black",
                  }}
                >
                  Through real-world tests, lockdown training, bomb threat
                  response, medical emergency response drills, parent pick-up
                  procedures, and lockdown prevention protocols, our training
                  helps reduce liability, enhance child protection, and create a
                  safer environment for both students and staff.
                </p>
                <p
                  className="lg:text-[18px] text-[14px]"
                  style={{
                    fontFamily: "poppins",

                    color: "black",
                  }}
                >
                  You’ll walk away with a toolkit that helps create a local
                  response manual tailored to your organization’s structure and
                  location, certified by emergency professionals.
                </p>
                <p
                  className="lg:text-[18px] text-[14px]"
                  style={{
                    fontFamily: "poppins",

                    color: "black",
                  }}
                >
                  This isn’t just another fire drill. This toolkit for
                  guardians, administrators, and educators just may be what’s
                  needed to decrease the unthinkable—because the unthinkable is
                  now thinkable.
                </p>
              </div>
            </div>
            {/* Info Section */}
            <div className="bg-[#FCF7EE]">
            <div className="max-w-7xl  lg:p-10 p-4 mb-10 mx-auto mt-8 px-4 flex flex-col md:flex-row items-start gap-6 md:gap-12">
              {/* Left Text Block */}
              <div className="w-full md:w-1/2">
                <h1
                  className="text-[26px] md:text-[32px] lg:text-[36px] font-bold leading-tight mb-4"
                  style={{ fontFamily: "Fredoka", color: "#000000" }}
                >
                  The Only National Accreditation That{" "}
                  <br className="hidden md:block" />
                  Protects AND Prepares
                </h1>
                <ul
                  className="text-[16px] md:text-[18px] lg:text-[20px] space-y-1 mb-4"
                  style={{ fontFamily: "Poppins", color: "#000000" }}
                >
                  <li>• The American Red Cross</li>
                  <li>• The American Heart Association</li>
                  <li>• The Department of Homeland Security</li>
                </ul>
                <p
                  className="text-[16px] md:text-[18px] lg:text-[20px]"
                  style={{ fontFamily: "Poppins", color: "#000000" }}
                >
                  Founded by a former U.S. Department of Defense contractor,
                  this system uses protocols built for post-9/11 government
                  facilities—adapted specifically for schools and daycares. This
                  isn’t repurposed corporate safety training. This is
                  life-saving preparation.
                </p>
              </div>

              {/* Right Image */}
              <div className="w-full md:w-[45%]">
                <img
                  src={boy}
                  alt="Caregivers training"
                  className="rounded w-full max-w-[460px] h-auto md:h-[374px] object-cover"
                />
              </div>
            </div>
            </div>
            {/* Protect Your Children Section */}
            <Protect img={Children2Img} />

            {/* Pricing Section */}
            <div className="max-w-6xl  bg-[#F0AA00] mx-auto rounded-md p-4 mt-10">
              <h2
                style={{ fontFamily: "Fredoka" }}
                className="lg:text-[30px] text-[20px] font-medium text-center text-white "
              >
                Schools that fail emergency inspections risk fines, lawsuits,
                and closure. AngelWatch instantly prepares your team to pass
                inspections and protect lives.
              </h2>
            </div>
            <h2
              style={{ fontFamily: "Fredoka" }}
              className="lg:text-[40px] text-[24px] mt-12 mb-10 font-bold text-center mb-12"
            >
              Avoid Fines and Protect Lives — Start Today
            </h2>
            <div className="max-w-7xl mx-auto">
            <div
              style={{ fontFamily: "Poppins" }}
              className="text-[18px]  mb-10 text-center"
            >
              The Individual Plan is a comprehensive training and certification
              platform designed for educators, caregivers, and child development
              professionals. It offers on-demand access to emergency
              preparedness training, compliance tracking, and certification
              management—all tailored for individuals who want to stay current,
              confident, and fully compliant in their field.
            </div>
            <div
              style={{ fontFamily: "Poppins" }}
              className="text-[18px]  mb-10 text-center"
            >
              The Center Plan is an all-inclusive Emergency Management System
              and Certification Platform for licensed schools and childcare
              providers. It replaces outdated methods with a modern solution
              that combines emergency training, full staff tracking, document
              compliance, and audit preparedness. This plan is built for center
              directors who need to manage and certify entire teams quickly and
              effectively.
            </div>
            </div>
          </div>
        </div>
        <div className="bg-[#FCF7EE]"></div>
      </div>

      <Package />
      <Review reviews={reviews} />
      <Footer />
    </>
  );
}
